








import {Component, Prop, Vue} from 'vue-property-decorator'

@Component
export default class LoadingSpinner extends Vue
{
    @Prop({default: '42'}) size: string
    @Prop({default: true}) centered: string
}
